<template>
  <div
    v-if="loaded"
    class="page"
  >
    <div class="page__sidebar">
      <audit-side-bar />
    </div>
    <div class="page__main">
      <router-view
        ref="mainContent"
        class="page__main-content"
      />
    </div>
  </div>
</template>

<script>
import AuditSideBar from './sideBar/AuditSideBar'

export default {
    name: 'AuditIndex',
    components: {
        AuditSideBar
    },
    data() {
        return {
            loaded: true
        }
    }
}

</script>
